import { useEffect, useState } from 'react'
import CenterContainer from '../../components/common/CenterContainer'
import LinkLocale from '../../modules/i18n/LinkLocale'
import { LOCALE_EN } from '../../modules/i18n/config'
import useTranslation from '../../modules/i18n/useTranslation'
import { IMG_GNB_APP } from '../../modules/images'
import urls from '../../modules/urls'

const EventBanner = ({ currentUser, ...props }) => {
  const { handleClose, portal } = props
  const { t, isLocaleKO, locale } = useTranslation()
  const [showBanner, setShowBanner] = useState(false)
  // const isMobile = useIsMobile()
  useEffect(() => {
    setIsMobile(window.innerWidth < 576)
  }, [])
  const [isMobile, setIsMobile] = useState(true)
  useEffect(() => {
    setShowBanner(true)
  }, [])
  const url = portal ? urls.student.portal.pricing.index : urls.student.landing.pricing

  const convertedLocale = isLocaleKO ? locale : LOCALE_EN

  return showBanner ? (
    isMobile ? (
      <LinkLocale href={url} className="position-relative" style={{ position: 'relative' }}>
        <div>
          <img src={IMG_GNB_APP(convertedLocale)} />
        </div>
      </LinkLocale>
    ) : (
      <LinkLocale href={url}>
        <div className="row flex h-[60px] cursor-pointer py-[12px]">
          <div
            style={{
              width: '50%',
              height: '60px',
              position: 'absolute',
              right: 0,
              top: 0,
              backgroundColor: '#E1E1E1',
            }}
          ></div>
          <div
            style={{
              width: '50%',
              height: '60px',
              position: 'absolute',
              left: 0,
              top: 0,
              backgroundColor: '#E1E1E1',
            }}
          ></div>
          <CenterContainer>
            <div className="relative mx-[0px] h-full px-[0px]">
              <div className="align-items-center justify-content-center flex h-full flex-row items-center justify-center">
                <div
                  style={{
                    color: '#3D3D3D',
                    borderColor: '#3D3D3D',
                  }}
                  className="border-t-1 border-b-1 text-bold mb-0 py-[3px] text-[14px] font-bold text-white"
                >
                  {t(['2월 EVENT', 'Feb EVENT'])}
                </div>
                <div style={{ color: '#3D3D3D' }} className="mx-[32px] text-[18px] font-bold">
                  {t([
                    '2월은 새벽반 혜택 받고 더 일찍 시작해 보세요!',
                    'Start earlier with Early Bird credit benefits in February!  ',
                  ])}
                </div>
                <div
                  style={{
                    backgroundColor: '#3D3D3D',
                  }}
                  className="rounded-[20px] py-[3px] px-[14px] text-[14px] font-medium text-white"
                >
                  {t(['자세히 보기', 'Learn More'])}
                </div>
              </div>
              <div
                onClick={handleClose}
                style={{ right: 8, top: -4 }}
                className="position-absolute z-index-1100 absolute w-[24px] cursor-pointer p-[10px] text-right"
              >
                <i style={{ color: '#3D3D3D' }} className=" fe fe-x"></i>
              </div>
            </div>
          </CenterContainer>
        </div>
      </LinkLocale>
    )
  ) : (
    <div></div>
  )
}
export default EventBanner
